import { useQuery, useQueryClient, useMutation } from "react-query";
import { fetchLocations, fetchSavedLocations, uploadToLocation, editLocation, addLocation, deleteLocation } from "../helpers/api";

export const useLocations = () => {
  const query = useQuery(["get-locations"], fetchLocations, {select: (data) => data,});
  return query;
};

export const useSavedLocations = () => {
  const query = useQuery(["get-saved-locations"], fetchSavedLocations, {select: (data) => data,});
  return query;
};

export const useAddLocation = () => {
  const queryClient = useQueryClient();
  queryClient.setMutationDefaults(["add-location"], {
    mutationFn: (data) => addLocation(data),
    onMutate: async (variables) => {
      const { successCb, errorCb } = variables;
      return { successCb, errorCb };
    },
    onSuccess: (result, variables, context) => {
      if (context.successCb) {
        context.successCb(result);
      }
    },
    onError: (error, variables, context) => {
      if (context.errorCb) {
        context.errorCb(error);
      }
    },
  });
  
  return useMutation(["add-location"]);
};

export const useEditLocation = () => {
  const queryClient = useQueryClient();
  queryClient.setMutationDefaults(["edit-location"], {
    mutationFn: (data) => editLocation(data),
    onMutate: async (variables) => {
      const { successCb, errorCb } = variables;
      return { successCb, errorCb };
    },
    onSuccess: (result, variables, context) => {
      if (context.successCb) {
        context.successCb(result);
      }
      queryClient.invalidateQueries(['get-locations']);
      queryClient.invalidateQueries(['get-saved-locations']);
    },
    onError: (error, variables, context) => {
      if (context.errorCb) {
        context.errorCb(error);
      }
    },
  });
  
  return useMutation(["edit-location"]);
};

export const useUploadToLocation = () => {
  const queryClient = useQueryClient();
  queryClient.setMutationDefaults(["upload-location"], {
    mutationFn: (data) => uploadToLocation(data),
    onMutate: async (variables) => {
      const { successCb, errorCb } = variables;
      return { successCb, errorCb };
    },
    onSuccess: (result, variables, context) => {
      if (context.successCb) {
        context.successCb(result);
      }
    },
    onError: (error, variables, context) => {
      if (context.errorCb) {
        context.errorCb(error);
      }
    },
  });
  
  return useMutation(["upload-location"]);
};

export const useDeleteLocation = () => {
  const queryClient = useQueryClient();
  queryClient.setMutationDefaults(["delete-location"], {
    mutationFn: (data) => deleteLocation(data),
    onMutate: async (variables) => {
      const { successCb, errorCb } = variables;
      return { successCb, errorCb };
    },
    onSuccess: (result, variables, context) => {
      if (context.successCb) {
        context.successCb(result);
      }
      queryClient.invalidateQueries(['get-saved-locations']);
    },
    onError: (error, variables, context) => {
      if (context.errorCb) {
        context.errorCb(error);
      }
    },
  });
  
  return useMutation(["delete-location"]);
};